import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from './composant/Header';
// import Footer from './components/Footer.jsx';
import Router from './Router';
import { ThemeProvider } from './theme/ThemeContext';



const App = () => {
  const isDisplayRoute = window.location.pathname === '/affichage';
  return (
    <ThemeProvider>
      <BrowserRouter>


      {!isDisplayRoute && <Header />}

      <main>
        <Router />
      </main>
      {/* <Footer /> */}

      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
